module.exports = __webpack_public_path__ + "img/residence-scholars.907c398a.webp";